/**
 * VideoGrid Component
 * 3-column grid layout for video thumbnails
 */

import { isClip } from '../../../../../types/prospect-media';
import type { ProspectVideo } from '../../../../../types/prospect-media';
import { VideoThumbnail } from './VideoThumbnail';
import './VideoGrid.css';

interface VideoGridProps {
  videos: ProspectVideo[];
  onVideoClick: (videoId: string) => void;
  onDeleteClick: (videoId: string) => void;
  getThumbnailUrl: (videoId: string) => Promise<string | null>;
  onClipClick?: (videoId: string) => void;
}

export function VideoGrid({
  videos,
  onVideoClick,
  onDeleteClick,
  getThumbnailUrl,
  onClipClick,
}: VideoGridProps) {
  return (
    <div className="video-grid">
      {videos.map((video) => (
        <VideoThumbnail
          key={video.id}
          video={video}
          onClick={() => onVideoClick(video.id)}
          onDelete={() => onDeleteClick(video.id)}
          getThumbnailUrl={getThumbnailUrl}
          // Clips are one level deep — you clip the original, never a clip.
          onClip={onClipClick && !isClip(video) ? () => onClipClick(video.id) : undefined}
        />
      ))}
    </div>
  );
}
